import { LoggerService } from "@core/logging/logger.service";

/**
 * Catches failures outside Angular's zone — primarily 3rd-party SDKs like
 * Gigya, which is loaded as a global script. In-zone errors go through
 * GlobalErrorHandler instead; the reporter's signature dedupe absorbs the
 * rare overlap. fatal() forwards to the error reporter via the LoggerService
 * remote seam (single-funnel rule).
 */
export function registerWindowErrorListeners(logger: LoggerService): void {
  const log = logger.createContext("WindowErrors");

  globalThis.addEventListener("error", (event) => {
    log.fatal("Uncaught error", event.error ?? event.message);
  });

  globalThis.addEventListener("unhandledrejection", (event) => {
    log.fatal("Unhandled promise rejection", event.reason);
  });
}
